<template>
  <div class="app-container" v-if="form">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <!-- 待付款--倒计时 -->
      <block v-if="form.state==1">
        <div class="time-title">等待买家付款</div>
        <div class="time-box">
          剩余支付时长：<el-statistic value-style="color:#F41313;" :value="deadline" format="DD天HH:mm:ss" time-indices></el-statistic>
        </div>
      </block>
      <div class="tab-box">
        <span :class="{'active': tabType === 1}" @click="tabType = 1">基础信息</span>
        <span :class="{'active': tabType === 2}" @click="tabType = 2">物流信息</span>
        <span :class="{'active': tabType === 3}" @click="tabType = 3">订单详情</span>
        <!-- <span :class="{'active': tabType === 4}" @click="tabType = 4">操作记录</span> -->
      </div>
      <template v-if="tabType==1">
        <div class="title-box"><span class="txt1">基础信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="订单编码">{{form.orderNum}}</el-descriptions-item>
          <el-descriptions-item label="随货同行单抬头">{{form.customerIdcard}}</el-descriptions-item>
          <el-descriptions-item label="订单来源">{{form.orderSource}}</el-descriptions-item>
          <el-descriptions-item label="快递方式">{{form.deliveryOptionsName}}</el-descriptions-item>
          <el-descriptions-item label="订单状态">{{form.state === 0?'已取消':(form.state === 1?'待付款':(form.state === 2?'待发货':(form.state === 3?'待收货':(form.state === 4?'已完成':'已失效'))))}}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{form.payTime}}</el-descriptions-item>
          <el-descriptions-item label="付款时间">{{form.payTime}}</el-descriptions-item>
          <el-descriptions-item label="通商云单号">{{form.tongShangYunOrderNum}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">下单人信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="下单人">{{form.custName}}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{form.custPho}}</el-descriptions-item>
          <el-descriptions-item label="所属区域">{{form.custAddrProvinceCodeName}}{{form.custAddrCityCodeName}}{{form.custAddrAreaCodeName}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">下单人从属关系</span></div>
        <el-descriptions :column="1">
          <el-descriptions-item label="技术线" v-if='form.techThree || form.techTwo || form.techOne'>
            <div class="fr1-body">
              <span class="blueColor">{{custTechLine}}</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="业务线">
            <div class="fr1-body">
              <span class="blueColor">{{custBusinessLine}}</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item v-if='form.nameCity' label="城市公司">{{form.nameCity}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">支付信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="商品总价">{{form.payTotalMoney}}积分</el-descriptions-item>
          <!-- <el-descriptions-item :label="'折扣立减' + (form.buyRatio? '(享体验班账户折扣:'+form.buyRatio+'折)':'')+'金额'">{{form.payDiscountMoney}}</el-descriptions-item> -->
          <el-descriptions-item label="运费">￥{{form.freight}}</el-descriptions-item>
          <!-- <el-descriptions-item label="凑单优惠">{{form.payDiscountMoney}}</el-descriptions-item> -->
          <el-descriptions-item label="实付金额">{{form.allPayMoney}}积分 + {{form.freight}}元</el-descriptions-item>
        </el-descriptions>
        <el-table :data="form.payTypeList" style="width: 100%">
          <el-table-column prop="name" label="支付方式" align="center"></el-table-column>
          <el-table-column prop="money" label="支付金额" align="center"> </el-table-column>
        </el-table>
      </template>
      <template v-else-if="tabType === 2">
        <div class="title-box"><span class="txt1">收货信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="收货人姓名">{{form.name}}</el-descriptions-item>
          <el-descriptions-item label="收货人联系方式">{{form.phone}}</el-descriptions-item>
          <el-descriptions-item label="联系人地址">{{form.addrProvince}}{{form.addrCity}}{{form.addrArea}}{{form.addrDetail}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">物流信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="发货时间">{{form.sendTime}}</el-descriptions-item>
        </el-descriptions>
        <el-table :data="form.logisticsNumber" style="width: 100%">
          <el-table-column prop="lable" label="包裹" align="center"></el-table-column>
          <el-table-column prop="num" label="快递编号" align="center"> </el-table-column>
          <el-table-column label="操作" align="center" width="230">
            <template slot-scope="{ row }">
              <el-button type="text" @click="lookLogistics(row)">查看物流</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="title-box"><span class="txt1">发货信息</span></div>
        <el-table :data="goodsList" style="width: 100%">
          <el-table-column prop="name" label="商品" align="center"></el-table-column>
          <el-table-column prop="aliasTitle" label="规格" align="center" key="5">
            <template slot-scope="{row}">
              {{row.spec || '无规格值'}}
            </template>
          </el-table-column>
          <!-- REQ-2026-234328 产品规格（如「10片/盒」）。与左边的「规格」是两个维度，
               本列取订单快照 snap_spec，存量订单回落 sys_goods.spec。 -->
          <el-table-column label="产品规格" align="center" key="5-1">
            <template slot-scope="{row}">
              {{row.productSpec || '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="jushuitanCode" label="聚水潭规格编码" align="center"></el-table-column>
          <el-table-column prop="combineCount" label="下单数量（件）" align="center"></el-table-column>
          <el-table-column label="是否为预售" align="center">
            <template slot-scope="{ row }">
              {{row.presell?'是':'否'}}
            </template>
          </el-table-column>
          <el-table-column prop="presellTime" label="预售商品距离预计发货时间还剩（天）" align="center"> </el-table-column>
          <el-table-column prop="sendNum" label="已发数量（件）" align="center"> </el-table-column>
          <el-table-column prop="daiNum" label="待发数量（件）" align="center"> </el-table-column>
        </el-table>
      </template>
      <template v-else-if="tabType === 3">
        <div class="title-box"><span class="txt1">基础信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="随货同行单">{{form.customerIdcard}}</el-descriptions-item>
          <el-descriptions-item label="收货人姓名">{{form.name}}</el-descriptions-item>
          <el-descriptions-item label="收货人联系方式">{{form.phone}}</el-descriptions-item>
          <el-descriptions-item label="联系人地址">{{form.addrProvince}}{{form.addrCity}}{{form.addrArea}}{{form.addrDetail}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">商品列表</span></div>
        <el-descriptions>
          <el-descriptions-item label="商品总价">{{form.payTotalMoney}}</el-descriptions-item>
          <el-descriptions-item label="折扣立减金额">{{form.payDiscountMoney}}</el-descriptions-item>
          <el-descriptions-item label="运费">{{form.freight}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions>
          <el-descriptions-item label="商品列表"></el-descriptions-item>
        </el-descriptions>
        <el-table :data="noSendList" style="width: 100%">
          <el-table-column label="序号" align="center" type="index">
            <template slot-scope="scope">
              {{ scope.$index+1 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
          <el-table-column prop="aliasTitle" label="规格" align="center">
            <template slot-scope="{row}">
              {{row.spec || '无规格值'}}
            </template>
          </el-table-column>
          <el-table-column label="产品规格" align="center">
            <template slot-scope="{row}">
              {{row.productSpec || '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="jushuitanCode" label="聚水潭规格编码" align="center"></el-table-column>
          <el-table-column prop="skuRetailPrice" label="市场价" align="center"> </el-table-column>
          <el-table-column prop="combineCount" label="数量" align="center"> </el-table-column>
          <el-table-column prop="tableMoney" label="小计" align="center"> </el-table-column>
        </el-table>
        <div class="all-price">商品总价：{{form.payTotalMoney}}积分 <span>邮费：￥{{form.freight}}</span> <span>实付款：<em>{{form.allPayMoney}}积分</em></span></div>
        <template v-if="sendList.length > 0">
          <el-descriptions class="mt10">
            <el-descriptions-item label="赠品列表"></el-descriptions-item>
          </el-descriptions>
          <el-table :data="sendList" style="width: 100%">
            <el-table-column label="序号" align="center" type="index">
              <template slot-scope="scope">
                {{ scope.$index+1 }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
            <el-table-column label="规格" align="center">
              <template slot-scope="{row}">
                {{row.spec || '无规格值'}}
              </template>
            </el-table-column>
            <el-table-column label="产品规格" align="center">
              <template slot-scope="{row}">
                {{row.productSpec || '-'}}
              </template>
            </el-table-column>
            <el-table-column prop="jushuitanCode" label="聚水潭规格编码" align="center"></el-table-column>
            <el-table-column prop="skuRetailPrice" label="市场价" align="center"> </el-table-column>
            <el-table-column prop="combineCount" label="数量" align="center"> </el-table-column>
            <el-table-column prop="tableMoney" label="小计" align="center"> </el-table-column>
          </el-table>
        </template>
        <!-- <el-descriptions>
          <el-descriptions-item label="商品总价">￥{{form.payTotalMoney}}</el-descriptions-item>
          <el-descriptions-item label="邮费">￥{{form.freight}}</el-descriptions-item>
          <el-descriptions-item label="优惠金额">￥{{form.payDiscountMoney || 0}}</el-descriptions-item>
          <el-descriptions-item label="实付款"><span class="redColor">￥{{form.allPayMoney}}</span></el-descriptions-item>
          <el-descriptions-item label="余额支付"><span class="redColor">￥{{form.payDiscountMoney || 0}}</span></el-descriptions-item>
          <el-descriptions-item label="微信支付"><span class="redColor">￥{{form.rmbMoney}}</span></el-descriptions-item>
        </el-descriptions> -->
      </template>
      <!-- <template v-else-if="tabType === 4">
        <div class="title-box"><span class="txt1">操作记录</span></div>
        <el-table :data="logList" style="width: 100%">
          <el-table-column prop="createdTime" label="操作时间" align="center" key="30"></el-table-column>
          <el-table-column prop="createdBy" label="操作人" align="center" key="31"></el-table-column>
          <el-table-column prop="title" label="操作内容" align="center" key="32"> </el-table-column>
        </el-table>
      </template> -->
    </el-card>
    <logistics-details-vue ref="logisticsDetailsVue" />
  </div>
</template>
<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import { Subtr, accMul } from '@/utils/index'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import logisticsDetailsVue from '@/views/common/logisticsDetails.vue';
import sysStepLogApi from '@/api/log/sysStepLog'
export default {
  props: ['rowItem'],
  components: { logisticsDetailsVue },
  data() {
    return {
      activeName: 2,
      tabType: 1,  //1基础信息 2 物流信息 3
      tableData: [],
      form: '',
      logistics: "",
      goodsList: [],
      sendList: [],
      noSendList: [],
      deadline: '',
      logList: []
    };
  },
  created() {
    this.activeName = +this.rowItem.activeName
    this.getDetails()
    // this.getLogList()

  },
  computed: {
    custBusinessLine() {
      const form = this.form
      const arr = []
      if (form.custOne) arr.push(form.nameCustOne + '【营销总监】')
      if (form.custTwo) arr.push(form.nameCustTwo + '【营销经理】')
      if (form.custThree) arr.push(form.nameCustThree + '【大区经理】')
      if (form.custFour) arr.push(form.nameCustFour + '【地区经理】')
      if (form.custFive) arr.push(form.nameCustFive + '【县区经理】')
      const self = form.custName + '【' + this.getCLevelLabel(form.custCLevel) + '】'
      return arr.length ? self + ' - ' + arr.reverse().join(' - ') : self
    },
    custTechLine() {
      const form = this.form
      const arr = []
      if (form.techOne) arr.push(form.nameTechOne + '【技术总监】')
      if (form.techTwo) arr.push(form.nameTechTwo + '【技术经理】')
      if (form.techThree) arr.push(form.nameTechThree + '【技术老师】')
      const self = form.custName + '【' + this.getCLevelLabel(form.custCLevel) + '】'
      return arr.length ? self + ' - ' + arr.reverse().join(' - ') : self
    },
  },
  methods: {
    getCLevelLabel(cLevel, customerType) {
      const map = { 1: '总监', 2: '营销经理', 3: '大区经理', 4: '地区经理', 5: '县区经理', 6: '研修班', 7: '体验班', 8: '普通人员' }
      if (cLevel && map[cLevel]) return map[cLevel]
      const tMap = { 1: '总监经理', 2: '业务员', 3: '加盟商' }
      return tMap[customerType] || ''
    },
    // getLogList() {
    //   sysStepLogApi.fetchList({ type: 2, foreignId: this.rowItem.id }).then(res => {
    //     this.logList = res.list;
    //   })
    // },
    getBisicsInfo() {
      sysDataconstantApi.fetchBatchCode({ code: 'order_point_cancel_time' }).then(({ data }) => {
        let { createdTime } = this.form
        let time = +data.list[0].content
        console.log(new Date(createdTime).getTime())
        this.deadline = new Date(createdTime).getTime() + time * 60 * 1000
        console.log(this.deadline)
      })
    },
    getDetails() {
      console.log(this.rowItem)
      goodsOrderApi.getGoodsDetail(this.rowItem.id).then(({ data }) => {
        data.logisticsNumber = data.logisticsNumber ? data.logisticsNumber.split(",") : [];
        if (data.logisticsNumber && data.logisticsNumber.length > 0) {
          data.logisticsNumber = this.arrayToObject(data.logisticsNumber);
        }
        data.payTypeList = [];
        let obj = {
          name: data.orderPayType === 1 ? '零售价' : (data.orderPayType === 2 ? '余额' : (data.orderPayType === 3 ? '积分' : (data.orderPayType === 4 ? '赠送' : (data.orderPayType === 5 ? '在线' : '组合')))),
          money: (data.orderPayType != 5 && data.orderPayType != 6) ? data.allPayMoney : (data.orderPayType == 5 ? data.rmbMoney : '余额:' + data.allPayMoney + '在线:' + data.rmbMoney)
        }
        data.payTypeList.push(obj);
        this.form = data;
        this.getLogisticsNumber(data.id);
        this.getBisicsInfo()
      })
    },
    arrayToObject(arr) {
      return arr.map((el, i) => ({
        lable: "包裹" + (i + 1),
        num: el,
      }));
    },
    // 物流信息
    getLogisticsNumber(logisticsNumber) {
      goodsOrderApi.getGoodsDetail({ logisticsNumber }).then(({ data }) => {
        this.logistics = data;
      })
    },
    // 查询发货信息相关商品信息
    getLogisticsNumber(id) {
      goodsOrderApi.getGoodsList({ orderId: id, pageSize: 1000  }).then(res => {
        let { list } = res.data, sendList = [], noSendList = [];
        if (list.length > 0) {
          list.forEach(it => {
            it.daiNum = Subtr(it.combineCount, it.sendNum);
            it.tableMoney = accMul(it.goodsPrice, it.combineCount);
            if (it.isSend) {
              sendList.push(it);
            } else {
              noSendList.push(it);
            }
          })
        }
        console.log(noSendList)
        this.goodsList = list;
        this.sendList = sendList;
        this.noSendList = noSendList;
      })
    },
    lookLogistics(row) {
      let { phone } = this.form;
      let str = phone ? `:${phone.trim().slice(-4)}` : ''
      this.$refs.logisticsDetailsVue.handleShow(row.num + str)
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  },
};
</script>
<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.title-cont {
  padding: 10px 20px;
  .fr3 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .fr3-body {
      width: 33.33%;
      font-size: 14px;
      color: #2e2f3e;
      line-height: 30px;
    }
  }
  .fr1 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .fr1-body {
      width: 100%;
      font-size: 14px;
      color: #2e2f3e;
      line-height: 30px;
    }
  }
}
.fr1-body {
  width: 100%;
  font-size: 14px;
  color: #2e2f3e;
}
.blueColor {
  color: #1596cd !important;
}
.redColor {
  color: #e73f3f !important;
}
.time-title {
  font-size: 30px;
  font-weight: 700;
  padding-bottom: 10px;
  color: #000000;
}
.time-box {
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #f41313;
  margin-bottom: 20px;
  .el-statistic {
    width: 140px !important;
  }
}
.all-price {
  text-align: right;
  font-size: 14px;
  color: #2e2f3e;
  margin-top: 20px;
  span {
    margin-left: 15px;
  }
  em {
    font-style: normal;
    color: #e73f3f;
  }
}
</style>
